<template>
  <div v-if="visible" class="popwin-overlay">
    <div class="popwin-content">
      <img class="close-btn" :src="closeImage"  @click="close()" alt="">
      <img :src="backgroundImage" alt="弹窗背景" class="popwin-bg" />
    </div>
  </div>
</template>

<script>
import { baseUrl } from '@/config/env'
import { mapState } from 'vuex'

export default {
  props: {
    backgroundIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      baseUrl,
      visible: true,
    }
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath']),
    backgroundImage () {
      // 假设背景图片的路径根据索引生成，可以根据实际路径调整
      return `${this.baseUrl.portalImg}${this.h5ConfigImgPath}/${this.h5ConfigDetails[0]['vainPicture']['vainPopImg'][this.backgroundIndex]}`
    },
    closeImage () {
      return `${this.baseUrl.portalImg}${this.h5ConfigImgPath}/${this.h5ConfigDetails[0]['vainOther']['vainCloseImg'][0]}`
    }
  },
  methods: {
    close() {
      this.visible = false
      this.$el.remove() // 移除弹窗的 DOM 元素
    },
  },
};
</script>

<style scoped>
  .popwin-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .popwin-content {
    position: relative;
    max-width: 100%;
    height: auto;
    overflow: hidden;
  }
  .popwin-bg {
    width: 100%;
    height: auto;
  }
  .close-btn {
    position: absolute;
    top: 0;
    right: 4.5rem;
    width: 2.5rem;
    height: auto;
  }
</style>
